import {
  PRINT_TEMPLATE_SETTING_ADD_REQUEST,
  PRINT_TEMPLATE_SETTING_ADD_SUCCESS,
  PRINT_TEMPLATE_SETTING_ADD_FAILURE,
  PRINT_TEMPLATE_SETTING_GET_REQUEST,
  PRINT_TEMPLATE_SETTING_GET_SUCCESS,
  PRINT_TEMPLATE_SETTING_GET_FAILURE,
  PRINT_TEMPLATE_SETTING_UPDATE_REQUEST,
  PRINT_TEMPLATE_SETTING_UPDATE_SUCCESS,
  PRINT_TEMPLATE_SETTING_UPDATE_FAILURE,
} from './actionTypes';
import printTemplateSettingService from '../../services/printTemplateSettingService';

export const printTemplateSettingAddRequest = () => ({
  type: PRINT_TEMPLATE_SETTING_ADD_REQUEST,
});

export const printTemplateSettingAddSuccess = (data) => ({
  type: PRINT_TEMPLATE_SETTING_ADD_SUCCESS,
  payload: data,
});

export const printTemplateSettingAddFailure = (error) => ({
  type: PRINT_TEMPLATE_SETTING_ADD_FAILURE,
  payload: error,
});

export const AddPrintTemplateSetting = (data) => {
  return async (dispatch) => {
    dispatch(printTemplateSettingAddRequest());
    try {
      const response = await printTemplateSettingService.addPrintTemplateSetting(data);
      dispatch(printTemplateSettingAddSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(printTemplateSettingAddFailure(error.response?.data || 'sipariş yazdırma ayarları eklenemedi!'));
      throw error;
    }
  };
};

// sipariş yazdırma ayarlarını çeker
export const printTemplateSettingGetRequest = () => ({
  type: PRINT_TEMPLATE_SETTING_GET_REQUEST,
});

export const printTemplateSettingGetSuccess = (data) => ({
  type: PRINT_TEMPLATE_SETTING_GET_SUCCESS,
  payload: data,
});

export const printTemplateSettingGetFailure = (error) => ({
  type: PRINT_TEMPLATE_SETTING_GET_FAILURE,
  payload: error,
});

export const GetPrintTemplateSettingAction = (userId) => {
  return async (dispatch) => {
    dispatch(printTemplateSettingGetRequest());
    try {
      const response = await printTemplateSettingService.getPrintTemplateSetting(userId);
      const list = response.data?.data?.data || [];
      dispatch(printTemplateSettingGetSuccess(list));
      return list;
    } catch (error) {
      dispatch(printTemplateSettingGetFailure(error.response?.data || 'sipariş yazdırma ayarları alınamadı!'));
      throw error;
    }
  };
};

export const printTemplateSettingUpdateRequest = () => ({
  type: PRINT_TEMPLATE_SETTING_UPDATE_REQUEST,
});

export const printTemplateSettingUpdateSuccess = (data) => ({
  type: PRINT_TEMPLATE_SETTING_UPDATE_SUCCESS,
  payload: data,
});

export const printTemplateSettingUpdateFailure = (error) => ({
  type: PRINT_TEMPLATE_SETTING_UPDATE_FAILURE,
  payload: error,
});

export const PrintTemplateSettingUpdate = (data) => {
  return async (dispatch) => {
    dispatch(printTemplateSettingUpdateRequest());
    try {
      const response = await printTemplateSettingService.printTemplateSettingUpdateApi(data);
      dispatch(printTemplateSettingUpdateSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(printTemplateSettingUpdateFailure(error.response?.data || 'sipariş yazdırma ayarları güncellenemedi!'));
      throw error;
    }
  };
};
